import axios from 'axios';

const table = body => {
    return axios.post('/post-tables', body).then(
        response => {
            const { table } = response.data;

            return table;
        },
        error => {
            const { response } = error;
            const { data } = response;
            const { errors } = data;

            return Promise.reject(errors);
        }
    );
};

const create = body => {
    return axios.post('/posts', body).then(
        response => {
            const { post } = response.data;

            return post;
        },
        error => {
            return Promise.reject(error.response.data.errors);
        }
    );
};

const edit = (id, body) => {
    return axios.put('/posts/' + id, body).then(
        response => {
            const { post } = response.data;

            return post;
        },
        error => {
            return Promise.reject(error.response.data.errors);
        }
    );
};

const find = id => {
    return axios.get('/posts/' + id).then(
        response => {
            const { post } = response.data;

            return post;
        },
        error => {
            const { response } = error;
            const { data } = response;
            const { errors } = data;

            return Promise.reject(errors);
        }
    );
};

const remove = id => {
    return axios.delete('/posts/' + id).then(
        () => {},
        error => {
            return Promise.reject(error.response.data.errors);
        }
    );
};

export const postServices = {
    table,
    create,
    edit,
    find,
    remove
};
